import CommonFunctions from '@common/util/functions.common';
import IntlMessage from '../../../helpers/intlMessage';
import React, { Component } from 'react';
const periodo = CommonFunctions.getPeriodosSubDays();

const inicialState = {
  dropdownOpen: false,
  dropdownOpenFavoritos: false,
  dropdownOpenOrdenacao: false,
  inputVazio: false,
  labelFiltroSelecionado: <IntlMessage id="dashboards.general.orderNumber" />,
  labelFiltroStatusSelecionado: 'Recebimento Material',
  idFiltroSelecionado: 9,
  tipoFiltroSelecionado: 'text',
  optionsFiltroInputTypeSelect: [],
  labelFavoritoSelecionado: 'Favoritos',
  labelOrdenacaoSelecionado: <IntlMessage id="dashboards.general.expectedDeliveryDate" />,
  tituloNovoFiltroFavorito: '',
  novoFiltroFavoritoIsDefault: false,
  showModalFavoritos: false,
  valorFiltro: undefined,
  etapaFiltro: '1',
  filtros: [],
  favoritos: [],
  filtrosSelecionados: [],
  periodoDe: periodo.periodoInicial,
  periodoAte: periodo.periodoFinal,
  optionsEtapasFiltro: [
    { label: 'Macroscopia', value: 1 },
    { label: 'Microscopia', value: 2 },
    { label: 'Histoquímica', value: 3 },
    { label: 'Imuno', value: 4 },
    { label: 'Fish', value: 5 },
    { label: 'Cish', value: 6 },
    { label: 'PCR', value: 7 },
    { label: 'Congelação', value: 8 },
    { label: 'Conclusão', value: 9 }
  ],
  ordenacao: [
    { label: <IntlMessage id="dashboards.general.expectedDelivery" />, value: 2 },
    { label: <IntlMessage id="dashboards.general.requestDate" />, value: 3 },
    { label: <IntlMessage id="dashboards.general.deliveryDate" />, value: 4 },
    { label: <IntlMessage id="dashboards.general.urgent" />, value: 5 },
    { label: <IntlMessage id="dashboards.general.immunohistochemistryTests" />, value: 6 }
  ],
  sentidoOrdenacaoASC: true,
  dropdownOpenGrupoUsuario: false,
  grupoUsuarios: [],
  labelGruposUsuario: '',
  idGrupoUsuario: undefined,
  statusEtapaSelecionada: undefined,
  filtrarPeriodoLaudo: [],
  labelFilterLinked: <IntlMessage id="dashboards.general.selectPeriod" />,
  optionsFiltrarPeriodoLaudo: [
    { value: 'hoje', label: <IntlMessage id="dashboards.general.today" /> },
    { value: 'ontem', label: <IntlMessage id="dashboards.general.yesterday" />},
    { value: 'semana', label: <IntlMessage id="dashboards.general.week" /> },
    { value: 'mes', label: <IntlMessage id="dashboards.general.month" /> },
  ],
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/main/filtros/filtro.state.js